import React from 'react';
import { Tag } from 'baseui/tag';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { useStyletron } from '../../Themes';
import { mergeOverrides } from 'baseui';
import { Theme } from '../../Themes/themeProvider/ThemeProvider';
import * as meta from '../../meta-data.json';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const [, theme]: [any, typeof Theme] = useStyletron();

	const { hoverColor, activeColor, actionHoverColor, actionActiveColor, actionIconColor, overrides, tagSize = 'default', ...rest } = props;

	const HTMLAttrs = getHTMLAttributes(props);
	const _hoverColor = !hoverColor && actionHoverColor ? actionHoverColor : hoverColor;
	const _activeColor = !activeColor && actionActiveColor ? actionActiveColor : activeColor;

	const defaultColors = {
		customColor: props.customColor,
		textColor: props.textColor,
		actionIconColor: props.actionIconColor || props.textColor,
		hoverColor: _hoverColor,
		activeColor: _activeColor,
	};

	return (
		<>
			<Tag
				data-epo={`epo-tag-${meta.version}`}
				ref={ref}
				//kind="custom"
				title={props.title}
				overrides={
					overrides
						? mergeOverrides(
							customOverrides(
								{
									...props,
									...defaultColors,
								},
								HTMLAttrs.dataProps,
								HTMLAttrs.ariaProps,
								theme,
								tagSize,
							) as any,
							overrides as any,
						)
						: (customOverrides(
							{
								...props,
								...defaultColors,
							},
							HTMLAttrs.dataProps,
							HTMLAttrs.ariaProps,
							theme,
							tagSize,
						) as any)
				}
				{...rest}
			>
				{props.children}
			</Tag>
		</>
	);
});
